import React, {useContext, useMemo} from 'react';
import styled from 'styled-components';

import Icon from 'components/icons/icon';

import theme, {bp, color} from 'settings/theme';

import {SearchContext} from 'services/searchService';


type Props = {
  filter: {
    name: string,
    value: string
  }
}


// Component
const Component: React.FC<Props> = (props) => {

  const search = useContext(SearchContext);

  const paramType = useMemo(() => {
    let paramType = search.paramTypes!.find(item => item.name === props.filter.name);
    return paramType;
  }, [props.filter.name, search.paramTypes]);

  const prefix = useMemo(() => (paramType?.existingFilterPrefix), [paramType]);

  const value = useMemo(() => {

    let newValue;

    // Keywords Param
    if(props.filter.name === 'keywords'){
      newValue = props.filter.value;
    }

    // String Params
    if(paramType?.type === 'string'){
      newValue = paramType.friendlyNames ? paramType.friendlyNames[props.filter.value] : props.filter.value;
    }


    // List params
    if(paramType?.type === 'list'){

      let values = props.filter.value.split('|');

      // If bands are being used
      if(paramType.bands){

        let newValues: any[] = [];
        let band = search.params!.product_type ? paramType.bands[search.params!.product_type] || paramType.bands.default : paramType.bands.default;

        for (const [ name, value ] of Object.entries(band)) {

          if(values.includes(name)){
            newValues.push(band[name].friendlyName);
          }

        }

        values = newValues;

      }

      // If friendly names are being used
      else if(paramType.friendlyNames){
        values = values.map(item => paramType.friendlyNames ? paramType.friendlyNames[item] : item);
      }

      newValue = values.join(', ');

    }

    return newValue;

  }, [props.filter.value, paramType]);

  // Remove a filter
  const handleRemoveFilter = () => {
    console.log("Calling removeParam!")
    search.removeParam!(props.filter.name);
    search.doSearch!();
  }

  return (
    <StyledComponent className="searchExistingFilter">

      <div className="searchExistingFilter-text">{`${prefix? `${prefix}: ` : ``}${value}`}</div>
      <div className="searchExistingFilter-button">
        <button onClick={handleRemoveFilter}>
          <Icon iconName="cross-circle" />
        </button>
      </div>
        
    </StyledComponent>
  );

}


export default Component;


// Styles
const StyledComponent = styled.div`

  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 36px;
  color: ${color.grey(30)};
  font-size: 14px;
  border-radius: 4px;
  background-color: ${color.grey(97)};

  .searchExistingFilter-text{
    flex: 1 1 auto;
    padding: 6px 10px;
    text-transform: capitalize;
  }

  .searchExistingFilter-button{

    flex: 0 0 auto;
    display: flex;
    position: relative;
    width: 36px;

    button{

      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 100%;
      border-radius: 4px;
      background-color: ${color.grey(95)};
      transition: background-color 0.15s ease-out;

      .icon{

        width: 18px;
        height: 18px;

        svg{
            fill: ${color.grey(30)};
        }

      }

      &:hover, &:focus{
        background-color: ${color.grey(90)};
      }

    }

  }

`;



